/**
 * 문장 중간에서 잘린 글을 마지막 완결 문장까지만 남긴다.
 *
 * Kakao 책 검색의 contents 는 약 250자에서 기계적으로 끊긴다.
 * "…사고로 아이를 잃은 젊은 부부" 처럼 마침표 없이 끝나므로
 * 그대로 보여주면 글이 고장난 것처럼 보인다.
 */

/** 마침표류 + 뒤따르는 닫는 기호. 뒤에 공백이나 끝이 와야 소수점을 피한다. */
const SENTENCE_END = /[.!?…](["'”’」』)\]]*)(?=\s|$)/g;

/** 이만큼도 안 남으면 자르는 대신 줄임표를 붙인다 */
const MIN_KEPT = 0.6;

export default function trimSentence(text) {
  const s = (text || "").trim();
  if (!s) return "";

  // 뒤에서부터 찾지 않고 전부 훑어 마지막 것을 쓴다.
  // 문자열 역방향 정규식이 없기도 하고, 겹치는 기호를 놓치지 않는다.
  let cut = -1;
  for (const m of s.matchAll(SENTENCE_END)) cut = m.index + m[0].length;

  // 완결 문장이 없거나 너무 앞에 있으면 반토막이 난다.
  // 『아몬드』처럼 250자 안에 마침표가 하나도 없는 소개문이 실제로 있다.
  if (cut < 0 || cut < s.length * MIN_KEPT) return s.replace(/[\s.]+$/, "") + "…";

  return s.slice(0, cut);
}
